import { useEffect, useState } from "react";
import api, { formatError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";

const EMPTY = { casual: "", sick: "", earned: "", remark: "", password: "" };

export const LeaveAdjustDialog = ({ target, onClose, onDone, monthLabel }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF(EMPTY); }, [target]);
  const submit = async () => {
    if (f.remark.trim().length < 3) { toast.error("Remark is mandatory (min 3 characters)"); return; }
    if (!f.password) { toast.error("Enter the password"); return; }
    setBusy(true);
    try {
      await api.post("/leave/balance/adjust", {
        employee_id: target.employeeId, year: target.year, month: target.month,
        casual: Number(f.casual) || 0, sick: Number(f.sick) || 0, earned: Number(f.earned) || 0,
        remark: f.remark.trim(), password: f.password,
      });
      toast.success("Leave balance adjusted");
      onDone?.(); onClose();
    } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!target} onOpenChange={(v) => { if (!v && !busy) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="lb-adjust-dialog">
        <DialogHeader>
          <DialogTitle>Adjust Leave Balance · {monthLabel} {target?.year}</DialogTitle>
          <DialogDescription>Use + to add days, − (e.g. -1) to deduct. Carries into the closing balance.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <div className="grid grid-cols-3 gap-2">
            {[["casual", "CL"], ["sick", "SL"], ["earned", "EL"]].map(([k, lbl]) => (
              <div key={k}>
                <Label className="text-[11px]">{lbl}</Label>
                <Input type="number" step="0.5" value={f[k]} placeholder="0"
                  onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`lb-adjust-${k}`} />
              </div>
            ))}
          </div>
          <div>
            <Label className="text-[11px]">Remark <span className="text-rose-600">*</span></Label>
            <Textarea rows={2} value={f.remark} onChange={(e) => setF({ ...f, remark: e.target.value })} data-testid="lb-adjust-remark" />
          </div>
          <div>
            <Label className="text-[11px]">Password <span className="text-rose-600">*</span></Label>
            <Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
              onKeyDown={(e) => e.key === "Enter" && submit()} data-testid="lb-adjust-password" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="lb-adjust-submit">
            {busy ? "Saving…" : "Save Adjustment"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
